module.exports = __webpack_public_path__ + "static/media/newLogo.98c5fdb2.svg";